import styled from 'vue-styled-components'

export default styled.div`
.labelColor > label {
  color: white !important;
}
.btn-save {
  display: flex;
  margin: 0 auto;
  width: 30%;
  justify-content: center;
}
.label {
  font-size: 1em;
}
.header-modal {
  background-color: #2962ff;
}
.modal-button-custom {
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  margin-top: 25px;
}
.button-group {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1.5em;
}
.mt-10 {
  margin-top: 10px;
}
.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 0.1rem !important;
}
.notices {
  z-index: 1000000000000000000 !important;
}
`;